import React from "react";
import Page, { PageProps } from "../Page";
import { IMenuItemsPresenter } from "../../../presenter/menu/MenuItemsPresenter";
import { Form } from "antd";
import CreateMenuItemForm, {
  CreateMenuItemFormProps
} from "./CreateMenuItemForm";
import UpdateMenuItemForm, {
  UpdateMenuItemFormProps
} from "./UpdateMenuItemForm";
import DataGrid from "../../components/app/grid/DataGrid";
import Loader from "../../components/Loader";
import TickBox from "../../components/app/grid/TickBox";
export interface Props extends PageProps {}
export interface State extends IMenuItemsPresenter {}

export default class MenuItemsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate, menuItems = [] } = this.state;
    const CreateForm = Form.create<CreateMenuItemFormProps>({})(
      CreateMenuItemForm
    );

    const UpdateForm = Form.create<UpdateMenuItemFormProps>({})(
      UpdateMenuItemForm
    );

    const columns = [
      {
        title: translate("menu_items_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("menu_items_page.url"),
        dataIndex: "url",
        key: "url"
      },
      {
        title: translate("menu_items_page.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("menu_items_page.menu_item_id"),
        dataIndex: "menu_item_id",
        key: "menu_item_id"
      },
      {
        title: translate("menu_items_page.rbr"),
        dataIndex: "rbr",
        key: "rbr"
      },

      {
        title: translate("menu_items_page.application_module"),
        key: "aplModCode",
        render: (text, record) => {
          return (
            <span>{translate(`menu_item_form.${record.aplModCode}`)}</span>
          );
        },
        sorter: (a, b) => {
          return String(a.aplModCode).localeCompare(String(b.aplModCode));
        }
      },
      {
        title: translate("reporting_periods.valid"),
        dataIndex: "valid",
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "5%"
      }
    ];

    menuItems = menuItems.sort((a, b) => a.rbr - b.rbr);

    const dataGrid = (
      <DataGrid
        title={translate("menu_items_page.title")}
        translate={translate}
        columns={columns}
        dataSource={menuItems}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        onStartUpdate={this.state.onStartUpdateHandler}
        onStartCreate={this.state.onStartCreateHandler}
        codebooks={this.state.availableMenuItems}
        onCreate={this.state.createMenuItem}
        createModalTitle={translate("menu_items_page.insert_modal_title")}
        updateForm={UpdateForm}
        updateModalTitle={translate("menu_items_page.update_modal_title")}
        onUpdate={this.state.updateMenuItem}
        addButtonText={translate("menu_items_page.add_button_text")}
        keyProperty={"id"}
        booleanColumnKeys={["valid"]}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          loading={this.state.loaders.menuItemsLoader}
          children={dataGrid}
          translate={translate}
        />
      </Page>
    );
  }
}
